<div class="slider-back" [hidden]="!showShadow">

</div>

<div [hidden]="!showShadow">
    <div class="slider" [ngClass]="{'shadow' : showShadow === true}" [@slideInOut]="animationState">
        <div class="tab-header">Create/Edit User
            <div class="btn-close-position" (click)="changeState(2)">
                <div class="btn-close">
                    <img src="assets/images/icons/Close.png">
                </div>
            </div>

        </div>
        <form (submit)="f.valid" class="form col-sm-12" #f="ngForm">
            <label class="labelPopup">First name</label>
            <input class="form-control" name="firstName" (input)="onInput($event)" [(ngModel)]="selectedUser.firstName" #firstName="ngModel" required
                autocomplete="off" placeholder="First name" />
            <div *ngIf="f.submitted && firstName.invalid" class="form-control-error">First name is required</div>
            <br>
            <label class="labelPopup">Last name</label>
            <input class="form-control" name="lastName" (input)="onInput($event)" [(ngModel)]="selectedUser.lastName" #lastName="ngModel" required
                autocomplete="off" placeholder="Last name" />
            <div *ngIf="f.submitted && lastName.invalid" class="form-control-error">Last name is required</div>
            <br>
            <label class="labelPopup">Phone</label>
            <br>
            <ngx-intl-tel-input  [preferredCountries]="preferredCountries"
                [enableAutoCountrySelect]="true" [enablePlaceholder]="true" [searchCountryFlag]="true"
                [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.Nigeria" [phoneValidation]="true"
                [separateDialCode]="separateDialCode" [numberFormat]="PhoneNumberFormat.National"
                name="phoneNumber" [(ngModel)]="phoneNumberObject" #phoneNumberControl="ngModel">
            </ngx-intl-tel-input>
            <div class="error-label"
                *ngIf="phoneNumberControl.invalid && (phoneNumberControl.dirty || phoneNumberControl.touched)">
                <small class="text-danger" *ngIf="phoneNumberControl.errors?.['required']">
                Phone number is required.
                </small>
                <small class="text-danger" *ngIf="phoneNumberControl.errors?.['validatePhoneNumber']">
                Please enter a valid phone number.
                </small>
            </div>
            <br>
            <label class="labelPopup">Email</label>
            <input class="form-control" name="email" type="email" [(ngModel)]="selectedUser.email" #email="ngModel" required email
                autocomplete="off" placeholder="Email" />
            <div *ngIf="f.submitted && email.invalid" class="form-control-error">Email is required</div>
            <div *ngIf="f.controls['email']?.invalid && f.controls['email']?.touched">
                <small style="color: red;" *ngIf="f.controls['email']?.errors?.['email']">Invalid email format.</small>
            </div>
            <label class="labelPopup mt-4">Enable OTP</label>
            <div  class="switch-wrapper" name="twoFactorEnabled" (click)="enableOTP()" [ngClass]="{'selected' : selectedUser.twoFactorEnabled}">
                <div class="switch"></div>
            </div>
            <br>
            <label class="labelPopup">Utility</label>
            <div class="utility-item-area">
                <div *ngFor="let a of utilities" class="utility-items" (click)="activateUtility(a)">
                    <span>{{a.name}}</span>
                    <div class="switch-wrapper" [ngClass]="{'selected' : isActiveUtility(a)}">
                        <div class="switch"></div>
                    </div>
                </div>
            </div>
            <br>
            <div class="app-wrapper">
                <div class="app-header">
                    <span>Applications</span>
                </div>
                <div *ngFor="let a of applications" class="app-items" (click)="activate(a)">
                    <span>{{a.name}}</span>
                    <div class="switch-wrapper" [ngClass]="{'selected' : isActive(a)}">
                        <div class="switch"></div>
                    </div>
                </div>
            </div><br>
        </form>
        <div class="sticky user-btn">
            <button class="submit col-xs-6" [disabled]="!f.valid" (click)="save()">Save</button>
            <button class="cancel-btn col-xs-6" (click)="changeState(2)">Cancel</button>
        </div>
    </div>
</div>